var HoverShapeView = require('../hoverShape/hoverShape'),
    GraphicStampModel = require('../../../models/coordinate/graphicStamp'),
    CreateImgEl = require('./createImgEl');


module.exports = HoverShapeView.extend({

    placedOpacity: GraphicStampModel.prototype.placedOpacity,
    hoverOpacity: GraphicStampModel.prototype.hoverOpacity,

    initialize: function( options ) {

        HoverShapeView.prototype.initialize.apply( this, arguments );

        this.stamp = this.note.uiModel.get('selectedStamp');

        this.width = this.stamp.getWidth();
        this.height = this.stamp.getHeight();

    },

    createEl: function() {

        return CreateImgEl(
            this.paper,
            this.stamp.getImgSrc(),
            this.ox,
            this.oy,
            this.width * this.originalScale,
            this.height * this.originalScale
        );

    },

    onMouseMove: function( x,y ) {

        this.el.attr({
            x: x,
            y: y
        });

    },

    /**
     * Note: for now don't need to worry about moving with scaling, as the user can only change the
     * scale with the mouse clicking buttons, menu items, or dragging a panel.  When doing this, the
     * mouse is no longer above the canvas so the element will not be visible.  When it returns it will
     * be in the correct position.
     */
    scale: function( scale ) {

        this.el.attr({
            width: this.width * scale,
            height: this.height * scale
        });

    },


    onBeforeDestroy: function() {
        this.stopListening();
        this.el.remove();
    }

});






/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/graphicStamp/hoverShape.js
 ** module id = 384
 ** module chunks = 0
 **/